// extracted by mini-css-extract-plugin
export var relatedPosts = "related-posts-module--related-posts--3p-qi";